import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

function SupplyChainAgent() {
  useEffect(() => {
    // Only load script once
    if (!document.getElementById("wxo-supplychain-script")) {
      window.wxOConfiguration = {
        orchestrationID:
          "70d163a79ddf4e54925d1e85aca292ea_c57ab471-e099-4df6-82e3-1f9dd0d7e05a",
        hostURL: "https://au-syd.watson-orchestrate.cloud.ibm.com",
        rootElementID: "supplychain-orchestrate-chat-root", // ✅ unique container
        deploymentPlatform: "ibmcloud",
        crn: "crn:v1:bluemix:public:watsonx-orchestrate:au-syd:a/70d163a79ddf4e54925d1e85aca292ea:c57ab471-e099-4df6-82e3-1f9dd0d7e05a::",
        chatOptions: {
          agentId: "e233950e-9fbb-4459-8b5e-fe75dfc71064",
          agentEnvironmentId: "a085f56a-e445-403a-b3d2-84c78d98639d",
        },
      };

      const script = document.createElement("script");
      script.id = "wxo-supplychain-script";
      script.src = `${window.wxOConfiguration.hostURL}/wxochat/wxoLoader.js?embed=true`;
      script.async = true;
      script.onload = () => {
        if (window.wxoLoader) window.wxoLoader.init();
      };
      document.body.appendChild(script);
    } else {
      // Re-init if script already loaded
      if (window.wxoLoader) window.wxoLoader.init();
    }

    return () => {
      // Clean up chat content only
      const chatRoot = document.getElementById("supplychain-orchestrate-chat-root");
      if (chatRoot) chatRoot.innerHTML = "";
    };
  }, []);

  return (
    <>
      {/* Hero Section */}
      <div
        className="text-center text-white bg_header mb-5"
        style={{
          background:
            "url('https://img.freepik.com/free-photo/containers-cargo-port_33799-123.jpg') center/cover",
          padding: "180px 0",
        }}
      >
        <h1 className="fw-bold mb-4">
          <span className="primary_text">
            Supply Chain & Cold Chain Optimization Agent
          </span>
        </h1>
        <p className="mb-5">
          Ensure safe, efficient, and cost-effective logistics with{" "}
          <span className="primary_text">AI-powered monitoring and optimization</span>.
        </p>
      </div>

      {/* Features Section */}
      <div className="container mt-5">
        <div className="row text-center invoice_box">
          <div className="col-md-4 mb-4">
            <div className="feature-box">
              <h4>📦 Real-time Monitoring</h4>
              <p>Track temperature, humidity, and location for cold-chain shipments.</p>
            </div>
          </div>
          <div className="col-md-4 mb-4">
            <div className="feature-box">
              <h4>🚚 Route Optimization</h4>
              <p>AI-driven route planning reduces delays and transport costs.</p>
            </div>
          </div>
          <div className="col-md-4 mb-4">
            <div className="feature-box">
              <h4>⚠️ Risk Detection</h4>
              <p>Predict disruptions and detect high-risk shipments instantly.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Advantages Section */}
      <div className="container my-5">
        <h2 className="text-center mb-4">🌟 Advantages</h2>
        <div className="row text-center">
          <div className="col-md-3 mb-4">
            <div className="p-3 shadow-sm rounded">
              <h5>✔ Reduced Spoilage</h5>
              <p>Protect perishable goods with real-time compliance alerts.</p>
            </div>
          </div>
          <div className="col-md-3 mb-4">
            <div className="p-3 shadow-sm rounded">
              <h5>✔ Cost Efficiency</h5>
              <p>Minimize fuel costs, delays, and unnecessary losses.</p>
            </div>
          </div>
          <div className="col-md-3 mb-4">
            <div className="p-3 shadow-sm rounded">
              <h5>✔ Faster Delivery</h5>
              <p>Optimize logistics operations and meet deadlines reliably.</p>
            </div>
          </div>
          <div className="col-md-3 mb-4">
            <div className="p-3 shadow-sm rounded">
              <h5>✔ Regulatory Compliance</h5>
              <p>Stay audit-ready with automated shipment records.</p>
            </div>
          </div>
        </div>
      </div>

      {/* How It Works Section */}
      <div className="container my-5">
        <h2 className="text-center mb-4">⚙️ How It Works</h2>
        <div className="row">
          <div className="col-md-4 text-center">
            <h5>1️⃣ Data Capture</h5>
            <p>Sensors and systems track shipments in real-time.</p>
          </div>
          <div className="col-md-4 text-center">
            <h5>2️⃣ AI Optimization</h5>
            <p>AI models analyze conditions, predict risks, and recommend actions.</p>
          </div>
          <div className="col-md-4 text-center">
            <h5>3️⃣ Actionable Insights</h5>
            <p>Get instant dashboards, alerts, and recommendations.</p>
          </div>
        </div>
      </div>

      {/* Agentic AI Section */}
      <div className="container my-5">
        <div className="card shadow-lg p-4">
          <h3 className="text-center mb-3">🤖 Role of Agentic AI</h3>
          <p className="text-center mb-4">
            Beyond analysis, Agentic AI takes proactive actions to maintain supply chain efficiency.
          </p>
          <ul>
            <li>🔔 Alerts logistics teams before temperature breaches occur.</li>
            <li>📧 Suggests alternative carriers when delays are detected.</li>
            <li>🔄 Continuously learns from past shipments to optimize routes.</li>
            <li>🧠 Acts as a co-pilot for your supply chain managers.</li>
          </ul>
        </div>
      </div>

      {/* Watson Chat Embed */}
      <div className="container my-5">
        <div className="card shadow-lg p-4">
          <h3 className="text-center mb-3">Interact with the Supply Chain Agent</h3>
          <p className="text-center">
            Ask questions, monitor shipments, and explore optimization strategies instantly.
          </p>
          <div id="supplychain-orchestrate-chat-root"></div>
        </div>
      </div>
    </>
  );
}

export default SupplyChainAgent;
